import {ARK} from './ark.js'
import {SilverArkDisplay} from './display.js'
import {SilverArkFocusable} from './focusable.js'

ARK.display = SilverArkDisplay
ARK.focusable = SilverArkFocusable

const event = require('@ali/silver-event')
event.init()

ARK.exposure('page_view', {
  eventId: 'page_view',
  eventName: 'page_view',
  page_view: 'page_view'
});
document.addEventListener('ykLogin', function(event) {
  const data = event.param
  ARK._log('loginsuccess', {
    eventId: 'loginsuccess',
    eventName: 'loginsuccess',
    youku_name: data.userName,
    loginsuccess: 'loginsuccess',
    youku_id: data.userId
  })
}, false)
window.ARK = ARK



// WEBPACK FOOTER //
// ./src/page/main/index.js